<script setup>
import { swalError } from '@/helper';
import { retrieve_children } from '@/services/child';
import { onMounted, ref } from 'vue';

const props = defineProps({
  user_id: {
    type: Number,
    required: true
  }
})

const isLoading = ref(true)
onMounted(async()=>{
  await get_children()
  isLoading.value = false
})

const children = ref([])
async function get_children(){
  let response = await retrieve_children({user_id: props.user_id})
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (!response.result.data.status.empty){
    children.value = response.result.data.children.data
  }
}
</script>

<template>
  <loadingCard v-if="isLoading"/>
  <div v-else class="card">
    <CardHeader title="Child List" :is_narrow="true" />
    <div class="card-body">
      <template v-if="children.length !== 0">
        <div v-for="child in children" :key="child.id" class="mb-2 card border shadow-none">
          <div class="card-body d-flex justify-content-between align-items-center">
            <div>
              <p>{{ child.attributes.name }}</p>
            </div>
            <div>
              <router-link class="btn btn-light-primary me-2"
                :to="{name: 'child-report', params: {id: child.id}}"
              >
                View Report
              </router-link>
              <router-link class="btn btn-light-success"
                :to="{name: 'dna-report-single-application', params: {id: child.id}}"
              >
                View Application
              </router-link>
            </div>
          </div>
        </div>
      </template>
      <EmptyCard v-else/>
    </div>
  </div>
</template>